/**
 * Public barrel export for the TableFilterDrawer organism (SE-7144).
 * @module features/player-kanban/components/organisms/TableFilterDrawer
 */
export { default } from "./TableFilterDrawerView";
export type { TableFilterDrawerProps } from "./TableFilterDrawerView";
